export default "__VITE_ASSET__J2uzW3O0__"